import React from 'react';
import RegisterMail from 'components/Login/RegisterMail';

export default (props) => (
  <RegisterMail {...props} />
);
